import {
    ADD_UPDATE_SUB_MODULE_MASTER_SUCCESS,
    ADD_UPDATE_SUB_MODULE_MASTER_FAILED,
    LOADING_ADD_UPDATE_SUB_MODULE_MASTER,
    NETWORK_ERROR_ADD_UPDATE_SUB_MODULE_MASTER
} from "../types/index";
import { adminServices } from "../../config/axios";

const adminAddEditSubModuleMaster =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_ADD_UPDATE_SUB_MODULE_MASTER });
        await adminServices
            .post("addOrUpdateSubModulemaster", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch({ type: ADD_UPDATE_SUB_MODULE_MASTER_SUCCESS, payload: res.data });
                        break;
                    default:
                        dispatch({ type: ADD_UPDATE_SUB_MODULE_MASTER_FAILED, payload: res.data });
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_ADD_UPDATE_SUB_MODULE_MASTER,
                    payload: err
                });
            });
    };

export { adminAddEditSubModuleMaster };
